import React, { useEffect } from "react";
import { Link } from "gatsby";
import "../styles/sections/contact.scss";
import { motion, useAnimation } from "framer-motion";
import { delayed, growRight, fadeIn } from "../components/animations";
import { useInView } from "react-intersection-observer";

export function ContactSection() {

  const animation = useAnimation();
  const [ref, inView] = useInView({ threshold: 0.2 });

  useEffect(() => {
    if (inView) {
      animation.start("visible");
    }
  }, [animation, inView]);

  return (
    <section ref={ref} className="contact-section">
      <div className="container">
        <ContactBanner animation={animation} />
        <motion.section
          variants={delayed(0.5, 200)}
          initial="hidden"
          animate={animation}
          className="contact-banner contact-information"
        >
          <section style={{color: 'white'}}>
            <h2>Contact</h2>
            <p style={{color: 'white'}}>tel: 657-216-2066</p>
            <p style={{color: 'white'}}>
              e: josec@westcoast-metalroofing.com
            </p>
          </section>
          <section>
            <h2>
              Business Info
            </h2>
            <p style={{color: 'white'}}>
              Mon - Fri; Hours <br />
              630 Jefferson st <br />
              Suite E <br />
              Placentia, CA 92870<br />
            </p>
            <p style={{color: 'white'}}>License #: C-39 1131855</p>
          </section>
          <Link to="/contact">
            Contact Us Here
          </Link>
        </motion.section>
      </div>
    </section>
  );
}

function ContactBanner({animation}) {
  return (
    <motion.div
      variants={delayed(0.5, -200)}
      initial="hidden"
      animate={animation}
      className="contact-banner"
    >
      <h2>
        Like what you see<span>?</span>
      </h2>
      <h1>
        Get in touch<span>.</span>
      </h1>
      <Link to="/contact">
        Email Us<span>!</span>
      </Link>
    </motion.div>
  );
}
